/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestLinkShiftWork } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface UserShiftWorkServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestLinkShiftWork 
     */
    shiftWorkControllerLinkViaApp0(apiRequestLinkShiftWork: ApiRequestLinkShiftWork, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param apiRequestLinkShiftWork 
     */
    shiftWorkControllerLinkViaApp1(apiRequestLinkShiftWork: ApiRequestLinkShiftWork, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param employerId 
     * @param apiRequestLinkShiftWork 
     */
    shiftWorkControllerLinkViaDashboard0(employerId: string, apiRequestLinkShiftWork: ApiRequestLinkShiftWork, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param employerId 
     * @param apiRequestLinkShiftWork 
     */
    shiftWorkControllerLinkViaDashboard1(employerId: string, apiRequestLinkShiftWork: ApiRequestLinkShiftWork, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param file 
     */
    shiftWorkControllerUpdatePlan0(file: Blob, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param file 
     */
    shiftWorkControllerUpdatePlan1(file: Blob, extraHttpRequestParams?: any): Observable<{}>;

}
